import { render } from "./CompleteWaiverModal.vue?vue&type=template&id=64ec5c9a"
import script from "./CompleteWaiverModal.vue?vue&type=script&lang=js"
export * from "./CompleteWaiverModal.vue?vue&type=script&lang=js"

import "./CompleteWaiverModal.vue?vue&type=style&index=0&id=64ec5c9a&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__